function setCookieY(cname, cvalue, exdays) {
              var d = new Date();
              d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
              var expires = "expires="+d.toUTCString();
              document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
            }
          	
function getCookieY(cname) {
              var name = cname + "=";
              var ca = document.cookie.split(';');
              for(var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                  c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                  return c.substring(name.length, c.length);
                }
              }
              return "";
}

document.addEventListener('DOMContentLoaded', function() {
    // Sélectionner tous les éléments avec la classe 'faq-item'
    var faqItems = document.querySelectorAll('.faq-item');

    // Ajouter un événement de clic à chaque élément de question
    faqItems.forEach(function(item) {
        var question = item.querySelector('.question');
        var reponse = item.querySelector('.reponse');

        question.addEventListener('click', function() {
            // Toggle visibility of the answer
            if (reponse.classList.contains('active')) {
                reponse.classList.remove('active');
                question.classList.remove('active');
            } else {
                reponse.classList.add('active');
                question.classList.add('active');
            }
        });
    });
});